<div class="field-text-display-wrapper">
  <div class="title">
    {{title}}
  </div>
  <span class="descritipn multiline-text-display"><ng-container *ngFor="let text of descriptionFormatDisplayArr"><ng-container *ngIf="!text.isStr && !text.isTranslateString"><span class="text" [innerHTML]="text.text"></span></ng-container><ng-container *ngIf="text.isTranslateString"><span class="job-translate-text">{{text.text | translate}}</span></ng-container></ng-container></span>
</div>